import React from 'react';

export function ZoomIcon(): React.JSX.Element {
	return (
		<svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="48" height="48" rx="12" fill="white" />
			<path
				d="M23.9995 39C32.2843 39 39 32.2838 39 23.9997C39 15.7156 32.2843 9 23.9995 9C15.7148 9 8.99976 15.7156 8.99976 23.9997C8.99976 32.2838 15.7154 39 23.9995 39Z"
				fill="#0C5CFF"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.8018 28.29H27.7225V21.0154C27.7225 19.9194 26.8343 19.0312 25.7384 19.0312H15.8176V26.3058C15.8176 27.4018 16.7058 28.29 17.8018 28.29ZM29.0447 25.645L33.0129 28.29V19.0312L29.0452 21.6767L29.0447 25.645Z"
				fill="white"
			/>
		</svg>
	);
}
